import { render, staticRenderFns } from "./SubWardRound.vue?vue&type=template&id=003e5468&"
import script from "./SubWardRound.vue?vue&type=script&lang=js&"
export * from "./SubWardRound.vue?vue&type=script&lang=js&"
import style0 from "./SubWardRound.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports